<template>
  <div class="input input--radios">
    <div
      v-for="v in values"
      :key="v.value"
      class="input input--radio d-flex align-baseline"
      :class="{ 'input--error': error, 'input--disabled': disabled }"
    >
      <input
        :id="`${id}-${v.value}`"
        :checked="value === v.value"
        type="radio"
        :name="id"
        :required="required"
        :disabled="disabled"
        @input="input(v.value)"
      />
      <label v-if="translate" :for="`${id}-${v.value}`" class="pl-0-4">
        {{ $t(v.label ? v.label : v.value) }}
      </label>
      <label v-else :for="`${id}-${v.value}`" class="pl-0-4">
        {{ v.label ? v.label : v.value }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputRadios',
  props: {
    id: { type: String, required: true },
    value: { type: String, required: true },
    values: { type: Array, required: true },
    required: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    translate: { type: Boolean, default: false },
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">
.input--radios {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: rem(-$spacing);
  margin-right: rem(-$spacing);

  .input--radio {
    margin: 0 rem($spacing);

    &.input--disabled {
      cursor: not-allowed;

      label {
        pointer-events: none;
      }
    }
  }
}
</style>
